var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "phone_missed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_937_933",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_937_933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone_missed_2",
    d: "M1.98308 11.9003L0.641415 10.5878C0.524749 10.4712 0.466415 10.3351 0.466415 10.1795C0.466415 10.024 0.524749 9.88785 0.641415 9.77118C1.49697 8.84757 2.48378 8.15486 3.60183 7.69306C4.71989 7.23125 5.85253 7.00035 6.99975 7.00035C8.14697 7.00035 9.27718 7.23125 10.3904 7.69306C11.5036 8.15486 12.4928 8.84757 13.3581 9.77118C13.4747 9.88785 13.5331 10.024 13.5331 10.1795C13.5331 10.3351 13.4747 10.4712 13.3581 10.5878L12.0164 11.9003C11.9095 12.0073 11.7855 12.0656 11.6445 12.0753C11.5036 12.0851 11.3747 12.0462 11.2581 11.9587L9.56642 10.6753C9.48864 10.617 9.4303 10.549 9.39142 10.4712C9.35253 10.3934 9.33308 10.3059 9.33308 10.2087V8.54618C8.96364 8.42952 8.58447 8.33716 8.19558 8.2691C7.80669 8.20104 7.40808 8.16702 6.99975 8.16702C6.59141 8.16702 6.1928 8.20104 5.80392 8.2691C5.41503 8.33716 5.03586 8.42952 4.66642 8.54618V10.2087C4.66642 10.3059 4.64697 10.3934 4.60808 10.4712C4.56919 10.549 4.51086 10.617 4.43308 10.6753L2.74142 11.9587C2.62475 12.0462 2.49593 12.0851 2.35496 12.0753C2.21398 12.0656 2.09003 12.0073 1.98308 11.9003ZM6.97058 6.62118L4.08308 3.73368V5.25035H2.91642V1.75035H6.41642V2.91702H4.89975L6.956 4.97327L10.2518 1.67743L11.0831 2.50868L6.97058 6.62118Z",
    fill: "#F8153B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMissed);
export default __webpack_public_path__ + "static/media/phone_missed.05f740646273e4a3ab94658fc076fa7c.svg";
export { ForwardRef as ReactComponent };